const pagination = {
  perPage: 10,
  currentPage: 1,
  total: 0,
  perPageOptions: [5, 10, 20, 25, 50],
};

const functions = {
  pagedData() {
    return this.reports['report1'].data.slice(this.from, this.to);
  },

  pagedRows() {
    return this.reports['report1'].rows.slice(this.from, this.to);
  },

  queriedData() {
    let result = this.reports['report1'].data;

    if (this.searchQueryE !== '') {
      result = this.fuseSearch.search('=' + this.searchQuery + '');
    }
    this.pagination.total = result.length;

    return result.slice(this.from, this.to);
  },

  to() {
    let highBound = this.from + this.pagination.perPage;
    if (this.total < highBound) {
      highBound = this.total;
    }

    return highBound;
  },

  from() {
    return this.pagination.perPage * (this.pagination.currentPage - 1);
  },

  total() {
    this.pagination.total = this.reports['report1'].rows.length;

    return this.pagination.total;
  },
};

export default { pagination, functions };
